import React from 'react'
import { Button, Badge, Tooltip } from '@mantine/core'
import { useMediumScreen } from '@/hooks'
import { fatal } from '@/utils'
import { useRebateProgramQuery } from '../queries'
import { useRebateClaimMutation } from '../mutations'

const AirdropTaskClaimRebateButton = () => {
  const { isMediumScreen } = useMediumScreen()

  const { data } = useRebateProgramQuery()

  const { mutateAsync, isLoading } = useRebateClaimMutation()

  const handleClaim = () => {
    mutateAsync()
  }

  if (data == null) {
    throw fatal('Rebate data should have been fetched by the previous screen.')
  }

  if (data.status === 'pending') {
    return (
      <Tooltip
        label="Rebates do not vest, and are processed daily. After claiming your rebate, you should see the tokens appear in your wallet after around 24 hours."
        withArrow
        wrapLines
        width={400}>
        <Badge variant="light" color="yellow">
          Pending
        </Badge>
      </Tooltip>
    )
  }

  return (
    <Button loading={isLoading} onClick={handleClaim} fullWidth={!isMediumScreen}>
      Claim
    </Button>
  )
}

export { AirdropTaskClaimRebateButton }
